import { render } from "./ResourceManagementDetail.vue?vue&type=template&id=edfeebfa&scoped=true&ts=true"
import script from "./ResourceManagementDetail.vue?vue&type=script&lang=ts"
export * from "./ResourceManagementDetail.vue?vue&type=script&lang=ts"

import "./ResourceManagementDetail.vue?vue&type=style&index=0&id=edfeebfa&scoped=true&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edfeebfa"]])

export default __exports__